<div class="row">
  <div class="col-lg-8">
    <div class="mb-4">
      <ng-container [ngTemplateOutlet]="formCard"></ng-container>
    </div>
  </div>
  <div class="col-lg-4">
    <retail-order-info (back)="back.emit()" (next)="validateForm()"></retail-order-info>
  </div>
</div>

<ng-template #formCard>
  <div [formGroup]="form">
    <mat-card class="mb-3">
      <mat-card-header>
        <mat-card-title>{{ 'Contact Info' | t }}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="form-group">
          <label for="emailField" class="col-form-label">{{ 'E-mail' | t }}:</label>
          <mat-form-field appearance="outline">
            <input id="emailField" matInput formControlName="email" />
            <mat-error>{{ formErrors['email'] | fieldError }}</mat-error>
          </mat-form-field>
        </div>
        <div class="form-group">
          <label for="phoneField" class="col-form-label">{{ 'Phone' | t }}:</label>
          <mat-form-field appearance="outline">
            <input id="phoneField" matInput formControlName="phone" />
            <mat-error>{{ formErrors['phone'] | fieldError }}</mat-error>
          </mat-form-field>
        </div>
        <div class="form-group">
          <label for="firstnameField" class="col-form-label">{{ 'First Name' | t }}:</label>
          <mat-form-field appearance="outline">
            <input id="firstnameField" matInput formControlName="firstname" />
            <mat-error>{{ formErrors['firstname'] | fieldError }}</mat-error>
          </mat-form-field>
        </div>
        <div class="form-group">
          <label for="lastnameField" class="col-form-label">{{ 'Last Name' | t }}:</label>
          <mat-form-field appearance="outline">
            <input id="lastnameField" matInput formControlName="lastname" />
            <mat-error>{{ formErrors['lastname'] | fieldError }}</mat-error>
          </mat-form-field>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="mb-3">
      <mat-card-content>
        <mat-checkbox formControlName="companyPurchase" color="primary">
          {{ 'Purchase for the company' | t }}
        </mat-checkbox>
        <div [class.d-none]="!showCompany">
          <div class="form-group">
            <label for="companyIdField" class="col-form-label">{{ 'Company ID' | t }}:</label>
            <mat-form-field appearance="outline">
              <input id="companyIdField" matInput formControlName="companyId" />
              <mat-error>{{ formErrors['companyId'] | fieldError }}</mat-error>
            </mat-form-field>
          </div>
          <div class="form-group">
            <label for="companyVatField" class="col-form-label">{{ 'VAT no' | t }}:</label>
            <mat-form-field appearance="outline">
              <input id="companyVatField" matInput formControlName="companyVat" />
              <mat-error>{{ formErrors['companyVat'] | fieldError }}</mat-error>
            </mat-form-field>
          </div>
          <div class="form-group">
            <label for="companyNameField" class="col-form-label">{{ 'Company Name' | t }}:</label>
            <mat-form-field appearance="outline">
              <input id="companyNameField" matInput formControlName="companyName" />
              <mat-error>{{ formErrors['companyName'] | fieldError }}</mat-error>
            </mat-form-field>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="mb-3">
      <mat-card-header>
        <mat-card-title>{{ 'Billing Info' | t }}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="form-group">
          <label for="streetField" class="col-form-label">{{ 'Street and no.' | t }}:</label>
          <mat-form-field appearance="outline">
            <input id="streetField" matInput formControlName="street" />
            <mat-error>{{ formErrors['street'] | fieldError }}</mat-error>
          </mat-form-field>
        </div>
        <div class="form-group">
          <label for="cityField" class="col-form-label">{{ 'City' | t }}:</label>
          <mat-form-field appearance="outline">
            <input id="cityField" matInput formControlName="city" />
            <mat-error>{{ formErrors['city'] | fieldError }}</mat-error>
          </mat-form-field>
        </div>
        <div class="form-group">
          <label for="postalcodeField" class="col-form-label">{{ 'Postal Code' | t }}:</label>
          <mat-form-field appearance="outline">
            <input id="postalcodeField" matInput formControlName="postalcode" />
            <mat-error>{{ formErrors['postalcode'] | fieldError }}</mat-error>
          </mat-form-field>
        </div>
        <div class="form-group">
          <label for="countryField" class="col-form-label">{{ 'Country' | t }}:</label>
          <mat-form-field appearance="outline">
            <mat-select id="countryField" formControlName="country">
              <mat-option *ngFor="let country of countries" [value]="country.value">{{ country.label }}</mat-option>
            </mat-select>
            <mat-error>{{ formErrors['country'] | fieldError }}</mat-error>
          </mat-form-field>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="mb-3" *ngIf="!isDeliveryPickup">
      <mat-card-content>
        <mat-checkbox formControlName="delivery" color="primary" (change)="switchDelivery($event.checked)">
          {{ 'Deliver to different address' | t }}
        </mat-checkbox>
        <div [class.d-none]="!showDelivery">
          <div class="form-group">
            <label for="deliveryNameField" class="col-form-label">{{ 'Addressee' | t }}:</label>
            <mat-form-field appearance="outline">
              <input id="deliveryNameField" matInput formControlName="deliveryName" />
              <mat-error>{{ formErrors['deliveryName'] | fieldError }}</mat-error>
            </mat-form-field>
          </div>
          <div class="form-group">
            <label for="deliveryStreetField" class="col-form-label">{{ 'Street and no.' | t }}:</label>
            <mat-form-field appearance="outline">
              <input id="deliveryStreetField" matInput formControlName="deliveryStreet" />
              <mat-error>{{ formErrors['deliveryStreet'] | fieldError }}</mat-error>
            </mat-form-field>
          </div>
          <div class="form-group">
            <label for="deliveryCityField" class="col-form-label">{{ 'City' | t }}:</label>
            <mat-form-field appearance="outline">
              <input id="deliveryCityField" matInput formControlName="deliveryCity" />
              <mat-error>{{ formErrors['deliveryCity'] | fieldError }}</mat-error>
            </mat-form-field>
          </div>
          <div class="form-group">
            <label for="deliveryPostalcodeField" class="col-form-label">{{ 'Postal Code' | t }}:</label>
            <mat-form-field appearance="outline">
              <input id="deliveryPostalcodeField" matInput formControlName="deliveryPostalcode" />
              <mat-error>{{ formErrors['deliveryPostalcode'] | fieldError }}</mat-error>
            </mat-form-field>
          </div>
          <div class="form-group">
            <label for="deliveryCountryField" class="col-form-label">{{ 'Country' | t }}:</label>
            <mat-form-field appearance="outline">
              <mat-select id="deliveryCountryField" formControlName="deliveryCountry">
                <mat-option *ngFor="let country of countries" [value]="country.value">{{ country.label }}</mat-option>
              </mat-select>
              <mat-error>{{ formErrors['deliveryCountry'] | fieldError }}</mat-error>
            </mat-form-field>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</ng-template>
